export function dataCivil(ano, mes, dia) {
    return { ano, mes, dia };
}
export function paraUTC(d) {
    return new Date(Date.UTC(d.ano, d.mes - 1, d.dia));
}
export function deUTC(d) {
    return { ano: d.getUTCFullYear(), mes: d.getUTCMonth() + 1, dia: d.getUTCDate() };
}
export function paraISO(d) {
    const mm = String(d.mes).padStart(2, "0");
    const dd = String(d.dia).padStart(2, "0");
    return `${d.ano}-${mm}-${dd}`;
}
export function deISO(iso) {
    const [a, m, d] = iso.split("-").map(Number);
    if (a === undefined || m === undefined || d === undefined) {
        throw new Error(`data invalida: ${iso}`);
    }
    return { ano: a, mes: m, dia: d };
}
export function somaDias(d, dias) {
    const t = paraUTC(d);
    t.setUTCDate(t.getUTCDate() + dias);
    return deUTC(t);
}
/** Dias corridos entre duas datas (b - a). */
export function diffDias(a, b) {
    const MS_DIA = 86_400_000;
    return Math.round((paraUTC(b).getTime() - paraUTC(a).getTime()) / MS_DIA);
}
export function comparaData(a, b) {
    return paraISO(a).localeCompare(paraISO(b));
}
/** 0 = domingo ... 6 = sabado */
export function diaDaSemana(d) {
    return paraUTC(d).getUTCDay();
}
export function ultimoDiaDoMes(ano, mes) {
    return deUTC(new Date(Date.UTC(ano, mes, 0)));
}
//# sourceMappingURL=data.js.map